
import { Appointment, Patient, Plan, ConsultationSettings, Reminder } from '../types';

export const checkScheduleConflict = (
  date: string, 
  time: string, 
  duration: number, 
  appointments: Appointment[], 
  excludeId?: number
): Appointment | null => {
  const requestedStart = new Date(`${date}T${time}`).getTime();
  const requestedEnd = requestedStart + duration * 60000;

  for (const apt of appointments) {
    if (apt.id === excludeId || apt.status === 'Cancelado' || apt.status === 'Faltou') continue;
    
    const aptStart = new Date(`${apt.date}T${apt.time}`).getTime();
    const aptEnd = aptStart + duration * 60000;

    const hasConflict = (
      (requestedStart >= aptStart && requestedStart < aptEnd) ||
      (requestedEnd > aptStart && requestedEnd <= aptEnd) ||
      (requestedStart <= aptStart && requestedEnd >= aptEnd)
    );

    if (hasConflict) return apt;
  }
  return null;
};

export const calculatePlanEndDate = (startDate: string, durationMonths: number): string => {
  const date = new Date(`${startDate}T00:00:00`);
  date.setMonth(date.getMonth() + durationMonths);
  date.setDate(date.getDate() - 1);
  return date.toISOString().split('T')[0];
};

export const formatCurrency = (value: number) => {
  return new Intl.NumberFormat('pt-BR', { style: 'currency', currency: 'BRL' }).format(value);
};

export const replaceTags = (
  text: string, 
  patient: Patient, 
  nutritionistName: string, 
  appointment?: Appointment,
  locationName?: string,
  settings?: ConsultationSettings
): string => {
  let result = text;
  result = result.replace(/\[NOME_PACIENTE\]/g, patient.name.split(' ')[0]);
  result = result.replace(/\[NOME_NUTRI\]/g, nutritionistName);
  
  if (appointment) {
    const [year, month, day] = appointment.date.split('-');
    const dateObj = new Date(`${appointment.date}T00:00:00`);
    
    const weekdays = ['Domingo', 'Segunda-feira', 'Terça-feira', 'Quarta-feira', 'Quinta-feira', 'Sexta-feira', 'Sábado'];
    const dayOfWeek = weekdays[dateObj.getDay()];

    result = result.replace(/\[DATA\]/g, `${day}/${month}/${year}`);
    result = result.replace(/\[HORA\]/g, appointment.time);
    result = result.replace(/\[DIA_SEMANA\]/g, dayOfWeek);
    result = result.replace(/\[LOCAL\]/g, locationName || appointment.modality || 'Local a definir');
  }

  if (settings) {
    result = result.replace(/\[DIAS_POSCONSULTA\]/g, String(settings.remindReturnAfterDays));
  }
  
  return result;
};

export const getWhatsAppLink = (phone: string, message: string) => {
  const cleanPhone = phone.replace(/\D/g, '');
  return `https://wa.me/55${cleanPhone}?text=${encodeURIComponent(message)}`;
};
